import { Typography } from '@recruit-robin/robin-theme/web-components';
import { ArrowLeft, Star_06 } from '@recruit-robin/robin-theme/web-icons';
import { useNavigate } from 'react-router-dom';

import { useDictionary } from '@/shared/lib/i18n';
import { routes } from 'config/routes';
import { useRobinJrAppStore } from 'shared/config/useRobinJrApp';
import { useStyles } from './RobinJrAppToggle.styles';

export const RobinJrAppToggle = () => {
  const classes = useStyles();
  const dictionary = useDictionary();
  const isRobinJrApp = useRobinJrAppStore((s) => s.isRobinJrApp);
  const toggleRobinJrApp = useRobinJrAppStore((s) => s.toggleRobinJrApp);
  const navigate = useNavigate();

  const handleToggleRobinJrApp = () => {
    toggleRobinJrApp();

    navigate(isRobinJrApp ? routes.home : routes.robinJr.home);
  };

  return (
    <div css={classes.root} onClick={handleToggleRobinJrApp}>
      {isRobinJrApp ? <ArrowLeft size={16} /> : <Star_06 size={16} />}

      <Typography variant={(v) => v.heading[6]} inline>
        {isRobinJrApp ? dictionary.backToRobin : dictionary.robinJr}
      </Typography>
    </div>
  );
};
